import React, { useEffect, useRef, useState } from "react";
import { Box, Flex, Image, Input, Text, Tabs, Tab, TabList,CardBody, TabPanels, Heading, Spacer, IconButton, Textarea, Checkbox, Button, Stack, TabPanel, Badge, Divider, Card, CardHeader, FormLabel, RadioGroup, Radio } from "@chakra-ui/react";
import MiniSideBar from "../../components/mini-sidebar";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import useLoader from "../../components/loader/loaderstates";
import SecondaryNav from "../../components/seconday-nav";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import { FaRegSave } from "react-icons/fa";
import { CopyIcon, EditIcon } from "@chakra-ui/icons";
import { CgRemove } from "react-icons/cg";
import { COLORS } from "../../components/styles/colors";
import { uploadPdfBaseURL, SaveSummaryCallLog, UploadFiletoFetchSummary } from "../../middleware/services/dischargesummarynotes";
import { calculateAgeCommonFunc, getLoginID, uploadImageCommonFunction, useScreenType } from "../../auth";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { MdDownload, MdOutlineMedicalInformation } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import { guid } from "@fullcalendar/core/internal";
import { CONFIG } from "../../appconfig/appconfig";
import AudioCompatibilityCheck from "../../components/patient-health/doctor-notes/notes-transcription/compatibility-check";
import CPUTranscribeNotes from "../../components/patient-health/doctor-notes/notes-transcription/CPU-transcription";
import GPUChunksTranscribeNotes from "../../components/patient-health/doctor-notes/notes-transcription/GPU-chunks-notes-transcription";
import DynamicModal from "../../components/dynamic-modal";
import { FetchPatientIPDData } from "../../middleware/services/ipdpatients";
import DisplayNotesModal from "../../components/patient-health/doctor-notes/notes-transcription/display-notes-modal";
import TranscriptNotesCard from "../../components/patient-health/doctor-notes/notes-transcription/display-notes";
import { fetchReferredHospital, GetDoctorNotes, updateDoctorNotes } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import { DischargePatient, FetchPatientDetails } from "../../middleware/services/messages";
import moment from "moment";
import { SlUser } from "react-icons/sl";
import DatePicker from "../../components/date-picker";
import { format } from "date-fns";
import { FaRegUser } from "react-icons/fa6";
import { FetchUsersByClinic } from "../../middleware/services/home";
import DropdownInputForVitals from "../../components/dropdown-input-forVitals";


// import { uploadImageCommonFunction, uploadPdfBaseURL } from "../../auth";

const DischargeSummaryIndex = (patId, apptmtId) => {
  const [selectedTab, setSelectedTab] = useState("doctor");
  // const [hideSection, sethideSection] = useState(false);
  const { showSuccessToast, showErrorToast } = Toaster();

  const [docUpload, setDocUpload] = useState(true);
  const [previewDoc, setPreviewDoc] = useState(false);
  const [hideMobile, setHideMobile] = useState(false);
  const [dispContent, setDispContent] = useState(false);
  const [doctoremail, setDoctorEmail] = useState(
    localStorage.getItem("email")
      ? localStorage.getItem("email")
      : ""
  );
  const dischargePatientModal = useRef();
  const navigate = useNavigate();
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const screenType = useScreenType()
  const [patienData, setPatienData] = useState(null);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  // ----------------------- Upload Document -----------------------------
  const [selectedImage, setSelectedImage] = useState(null);
  const [data, setData] = useState(null);

  const handleuploadDocumentAttachment = () => {
    document.getElementById("uploaddocument").click();
  }
  const [base64PDF, setBase64PDF] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [docUrl, setDocUrl] = useState("");
  const [AIInput, setAIInput] = useState(null);
  // const [dischargeSummary, setDischargeSummary] = useState(null);
  const [downloadSummaryId, setDownloadSummaryId] = useState(null);
  const [ShowThanksScreen, setShowThanksScreen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); // Stores multiple file previews

  const [patientid, setPatientid] = useState("");
  const [appointmentid, setAppointmentid] = useState("");
  const [doctrId, setDoctrId] = useState("");
  const [patientDischargeType, setPatientDischargeType] = useState("");
  const [patientIpdData, setPatientIpdData] = useState(null);
  const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
  const [dischargeDate, setDischargeDate] = useState(moment().format("DD-MM-yyyy"));
  const [time, setTime] = useState(moment().format("HH:mm"));
  var [DoctorList, setDoctorList] = useState([]);
  var [doctorData, setDoctorData] = useState([]);
  var [DefaultDoctor, setDefaultDoctor] = useState(null);
  const [isSavedDischarge, setIsSavedDischarge] = useState(false);
  const [dischargeType, setDischargeType] = useState("");
  const [dischargeTypeText, setDischargeTypeText] = useState("");

  // useEffect(() => {
  //     // setActionAccessPatients(actionAccessMain(4))
  //     const currentUrl = window.location.href;
  //     const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
  //     const id = searchParams.get('patientId');
  //     const apmtid = searchParams.get('appointmentId');
  //     setPatientid(id);
  //     setAppointmentid(id);
  //     // fetchmediationdata(id)   
  //   }, []);

  // Helper function to calculate age from date string
  function calculateAge(dateString) {
    if (!dateString) return 0;
    const birthDate = new Date(dateString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  // Function to convert "2025-10-17T12:05:00" to "17th Oct, 2025 at 12:05 p.m."
const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return null;
  
  try {
    const date = new Date(dateTimeString);
    
    // Get day with ordinal suffix
    const day = date.getDate();
    const dayWithSuffix = day + (day % 10 === 1 && day !== 11 ? 'st' : 
                               day % 10 === 2 && day !== 12 ? 'nd' : 
                               day % 10 === 3 && day !== 13 ? 'rd' : 'th');
    
    // Get month abbreviation
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    
    // Get year
    const year = date.getFullYear();
    
    // Format time in 12-hour format with a.m./p.m.
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'p.m.' : 'a.m.';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    
    return `${dayWithSuffix} ${month}, ${year} at ${hours}:${minutes} ${ampm}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return null;
  }
};

// const [doctorNotesData, setDoctorNotesData] = useState('')
  const fetchIpdPatientData = async (ptntid, aptmntid, docid) => {
    showLoader()
    try {
      const resp = await GetDoctorNotes({
        patientid: ptntid,
        appointmentid: aptmntid,
        doctorid: docid,
      });
      // console.log('respIPDDataPatient: ', resp)

      if (resp?.output?.data) {
        const patientData = resp.output.data;
        const docData = resp.output.data?.followupdetail?.referraldoctor;

         // Normalize and set DefaultDoctor as a fullname string
        const resolveDoctorNameFromPayload = async (d) => {
          if (!d && !docid) return "";
          // If API already returned an object with fullname
          if (d && typeof d === "object" && d.fullname) return d.fullname;
          // If API returned a string fullname
          if (d && typeof d === "string") {
            // If it's numeric string, try resolve by id
            if (!isNaN(Number(d))) {
              const found = doctorData.find(doc => Number(doc.doctorid) === Number(d));
              if (found) return found.fullname;
              // fallback: fetch doctors and try again
              const fresh = await fetchDoctors(Number(d));
              const f = fresh && fresh.find(doc => Number(doc.doctorid) === Number(d));
              return f ? f.fullname : d;
            }
            // non-numeric string -> assume it's fullname
            return d;
          }
          // If API returned numeric id
          if (typeof d === "number") {
            const found = doctorData.find(doc => Number(doc.doctorid) === Number(d));
            if (found) return found.fullname;
            const fresh = await fetchDoctors(Number(d));
            const f = fresh && fresh.find(doc => Number(doc.doctorid) === Number(d));
            return f ? f.fullname : String(d);
          }
          // fallback to docid from URL if provided
          if (docid) {
            const found = doctorData.find(doc => Number(doc.doctorid) === Number(docid));
            if (found) return found.fullname;
            const fresh = await fetchDoctors(Number(docid));
            const f = fresh && fresh.find(doc => Number(doc.doctorid) === Number(docid));
            return f ? f.fullname : "";
          }
          return "";
        };
        const resolvedName = await resolveDoctorNameFromPayload(docData);
        if (resolvedName) {
          setDefaultDoctor(resolvedName);
        }

        // setDefaultDoctor(docData)
        const referralCenterData = resp.output.data?.followupdetail?.referraltohighercenters;
        setReferralCenter(referralCenterData)
        const dischargeTypeData = resp.output.data?.info?.discharge_type;
        setDischargeType(dischargeTypeData)

        // First group and combine the vitals properly
        const groupedVitals = {};
        const bloodPressures = [];

        // Process all vitals
        patientData.vitals?.forEach(vital => {
          // Special handling for blood pressure
          if (vital.vitalname === "Systolic Blood Pressure" || vital.vitalname === "Diastolic Blood Pressure") {
            return; // We'll handle these separately
          }

          if (!groupedVitals[vital.vitalname]) {
            groupedVitals[vital.vitalname] = {
              values: [],
              unit: vital.vitalunit
            };
          }
          groupedVitals[vital.vitalname].values.push(vital.vitalvalue);
        });

        // Process blood pressure readings by matching systolic and diastolic pairs
        const systolicReadings = patientData.vitals?.filter(v => v.vitalname === "Systolic Blood Pressure");
        const diastolicReadings = patientData.vitals?.filter(v => v.vitalname === "Diastolic Blood Pressure");

        // Pair them up by timestamp (assuming same timestamp means same reading)
        const bpReadings = [];
        const maxLength = Math.max(systolicReadings?.length || 0, diastolicReadings?.length || 0);

        for (let i = 0; i < maxLength; i++) {
          const systolic = systolicReadings?.[i]?.vitalvalue || "";
          const diastolic = diastolicReadings?.[i]?.vitalvalue || "";
          if (systolic || diastolic) {
            bpReadings.push(`${systolic}/${diastolic}`);
          }
        }

        // Add blood pressure to grouped vitals if we have readings
        if (bpReadings.length > 0) {
          groupedVitals["Blood Pressure"] = {
            values: bpReadings,
            unit: "mmHg"
          };
        }
        // Convert to the final vitals array format
        const finalVitals = Object.entries(groupedVitals).map(([name, data]) => ({
          vitalname: name,
          vitalvalue: data.values.join(', '),
          vitalunit: data.unit
        }));
        // patientData.vitals?.forEach(vital => {
        //   if (!groupedVitals[vital.vitalname]) {
        //     groupedVitals[vital.vitalname] = [];
        //   }
        //   groupedVitals[vital.vitalname].push(vital.vitalvalue);
        // });

        // Transform the data into the required format

        const currentFormattedDate = moment().format("Do-MMM-YYYY");
        const aiInputData = {
  has_midoc_idp: "True",

  // admission details
  // admission_date: patientData.info?.appointmentdate ? formatDate(patientData.info.appointmentdate) : null,
  admission_date: patientData.info?.admindate ? formatDateTime(patientData.info.admindate) : null,
  discharge_date: patientData.info?.dischargedate ? formatDateTime(patientData.info.dischargedate) : null,
  // discharge_date: currentFormattedDate, 
  consultant_doctor: patientData.info?.drname || null,
  follow_up_date: patientData.info?.followupdate ? formatDate(patientData.info.followupdate) : null,
  
  // patient details
  patient_info: {
    name: patientData.info?.patientname || "Unknown",
    dateOfBirth: patientData.info?.patientage || "Unknown",
    age: calculateAge(patientData.info?.patientage) || 0,
    gender: patientData.info?.patientgender || "Unknown",
    phone: `${patientData.info?.patientcountrycode} ${patientData.info?.patientphone}` || "Unknown",
    uhid: patientData.info?.bookingid || "Unknown",
    mrn: patientData.info?.patientmrn || "Unknown"
  },
  
  // medications
  currentmedications: patientData.prescriptionresult?.map(med => ({
    medicinename: med.medicinename,
    dosage: `${med.dosage} ${med.dosageunit}`,
    instructions: med.afterfood ? "Take after food" : med.beforefood ? "Take before food" : "As directed",
    interval: med.frequencytime ? `Every ${med.frequencyvalue} ${med.frequencytime}` : "As needed",
    duration: med.duration || null
  })) || [],
  
  // investigations
  investigations: [
    ...(patientData.labresults?.map(lab => ({
      eventtitle: lab.eventtitle,
      actualresultvalue: lab.actualresultvalue,
      resultuom: lab.resultuom,
      reference_range: `${lab.lower_bound || 'N/A'} - ${lab.upper_bound || 'N/A'}`,
      type: "lab"
    })) || []),
    ...(patientData.imagingresults?.map(img => ({
      eventtitle: img.reportname,
      actualresultvalue: img.results_interpretation?.abnormal_results || "Normal findings",
      resultuom: "",
      type: "imaging"
    })) || [])
  ],
  
  // vitals
  vitals: finalVitals,
  
  // doctor notes
  doctornotes: [
    ...(patientData.generalnotes?.map(note => ({
      name: note.doctorname,
      notes: note.generalnote,
      date: note.createddate
    })) || []),
    ...(patientData.dieticiannote?.map(note => ({
      name: "Dietician",
      notes: note.dietnote,
      date: note.createddate
    })) || [])
  ],  
  
  // imaging results
  imaging_reports: patientData.imagingresults?.map(img => ({
    report_info: {
      name: img.reportname,
      type: "diagnostic",
      description: img.reportdescription
    },
    results_interpretation: {
      normal_results: img.results_interpretation?.normal_results || "",
      abnormal_results: img.results_interpretation?.abnormal_results || "",
      report_interpretation: img.results_interpretation?.report_interpretation || ""
    }
  })) || [],

  // newly added tags
  diagnosis: patientData.doctorsassessment?.map(d => ({
    condition: d.diagnosis,
    plan: d.plan
  })) || [],
  
  // FIXED: presenting_complaints - handle object instead of array
  presenting_complaints: {
    chief_complaint: patientData.chiefcomplaint?.chiefcomplaint || "",
    complaint_date: patientData.chiefcomplaint?.date || null,
    // FIX: hpitext is an object, not array
    history_of_illness: patientData.hpitext ? [{
      description: patientData.hpitext.description,
      type: patientData.hpitext.type,
      // id: patientData.hpitext.id
    }] : [],
  },
  
  // FIXED: clinical_findings - handle objects instead of arrays
  clinical_findings: {
    // FIX: physicalexamtext is an object, not array
    physical_exam: patientData.physicalexamtext ? [{
      description: patientData.physicalexamtext.description,
      type: patientData.physicalexamtext.type,
      // id: patientData.physicalexamtext.id
    }] : [],
    
    // FIX: rostext is an object, not array
    review_of_systems: patientData.rostext ? [{
      description: patientData.rostext.description,
      type: patientData.rostext.type,
      // id: patientData.rostext.id
    }] : [],
    
    vitals: finalVitals,
  },
  
  history: {
    medical_history: patientData.medicalhistory?.map(h => ({
      condition: h.condition,
      diagnosis_date: h.conditionidentifieddate
    })) || [],
    surgical_history: patientData.orders?.procedure?.map(p => ({
      procedure: p.ordername,
      order_date: p.orderdate
    })) || []
  },
  
  hospital_course: {
    procedures: patientData.orders?.procedure?.map(p => p.ordername) || [],
    vaccinations: patientData.orders?.vaccinationdetail?.map(v => ({
      vaccine: v.vaccinename,
      date: v.admindate
    })) || [],
    orders: {
      lab: patientData.orders?.lab?.map(l => l.ordername) || [],
      imaging: patientData.orders?.imaging?.map(i => i.ordername) || []
    }
  },
  
  instructions: [
    ...(patientData.generalnotes?.map(note => note.generalnote) || []),
    ...(patientData.dieticiannote?.map(note => note.dietnote) || [])
  ],
  
  follow_up_plan: {
    follow_up_date: patientData.info?.followupdate || null,
    instructions: patientData.doctorsassessment?.[0]?.plan || null
  },
};
        // last commented input
//         const aiInputData = {
//   // transcription: `Patient with problem`,
//   has_midoc_idp: "True",

//   // admission details
//   admission_date: patientData.info?.appointmentdate ? formatDate(patientData.info.appointmentdate) : null,
//   discharge_date: null, // Not available in original data
//   consultant_doctor: patientData.info?.drname || null,
//   follow_up_date: patientData.info?.followupdate ? formatDate(patientData.info.followupdate) : null,
//   // patient details
//   patient_info: {
//     name: patientData.info?.patientname || "Unknown",
//     dateOfBirth: patientData.info?.patientage || "Unknown",
//     age: calculateAge(patientData.info?.patientage) || 0,
//     gender: patientData.info?.patientgender || "Unknown",
//     // mrn: patientData.info?.patientmrn || null,
//     // phone: patientData.info?.patientphone || null
//   },
//   // medications
//   currentmedications: patientData.prescriptionresult?.map(med => ({
//     medicinename: med.medicinename,
//     dosage: `${med.dosage} ${med.dosageunit}`,
//     instructions: med.afterfood ? "Take after food" : med.beforefood ? "Take before food" : "As directed",
//     interval: med.frequencytime ? `Every ${med.frequencyvalue} ${med.frequencytime}` : "As needed",
//     duration: med.duration || null
//   })) || [],
//   // investigations
//   investigations: [
//     ...(patientData.labresults?.map(lab => ({
//       eventtitle: lab.eventtitle,
//       actualresultvalue: lab.actualresultvalue,
//       resultuom: lab.resultuom,
//       reference_range: `${lab.lower_bound || 'N/A'} - ${lab.upper_bound || 'N/A'}`,
//       type: "lab"
//     })) || []),
//     ...(patientData.imagingresults?.map(img => ({
//       eventtitle: img.reportname,
//       actualresultvalue: img.results_interpretation?.abnormal_results || "Normal findings",
//       resultuom: "",
//       type: "imaging"
//     })) || [])
//   ],
//   // vitals
//   vitals: finalVitals,
//   // doctor notes
//   doctornotes: [
//             ...(patientData.generalnotes?.map(note => ({
//               name: note.doctorname,
//               notes: note.generalnote,
//               date: note.createddate
//             })) || []),
//             ...(patientData.dieticiannote?.map(note => ({
//               name: "Dietician",
//               notes: note.dietnote,
//               date: note.createddate
//             })) || [])
//           ],  
//   // imaging results
//   imaging_reports: patientData.imagingresults?.map(img => ({
//     report_info: {
//       name: img.reportname,
//       type: "diagnostic",
//       description: img.reportdescription
//     },
//     results_interpretation: {
//       normal_results: img.results_interpretation?.normal_results || "",
//       abnormal_results: img.results_interpretation?.abnormal_results || "",
//       report_interpretation: img.results_interpretation?.report_interpretation || ""
//     }
//   })) || [],

//   // newly added tags
//   diagnosis: patientData.doctorsassessment?.map(d => ({
//     condition: d.diagnosis,
//     plan: d.plan
//   })) || [],
//   presenting_complaints: {
//     chief_complaint: patientData.chiefcomplaint?.chiefcomplaint || "",
//     complaint_date: patientData.chiefcomplaint?.date || null,
//     history_of_illness: patientData.hpitext?.map(d => ({
//       description: d.description,
//       type: d.type
//     })) || [],
//     // history_of_illness: patientData.historyofpresentillness?.map(illness => {
//     //   const details = {};
//     //   illness.details?.forEach(detail => {
//     //     if (detail.values) {
//     //       details[detail.attribute] = detail.values.map(v => v.value).join(', ');
//     //     } else {
//     //       details[detail.attribute] = detail.value;
//     //     }
//     //   });
//     //   return {
//     //     type: illness.type,
//     //     details: details
//     //   };
//     // }) || []
//   },
//   clinical_findings: {
//     // physical_exam: patientData.physicalexam?.flatMap(exam =>
//     //   exam.physicalexam?.map(item => ({
//     //     system: exam.type,
//     //     finding: item.examvalue,
//     //     abnormal: item.indicator === 1
//     //   })) || []
//     // ) || [],
//     physical_exam: patientData.physicalexamtext?.map(d => ({
//       description: d.description,
//       type: d.type
//     })) || [],
//     review_of_systems: patientData.rostext?.map(d => ({
//       description: d.description,
//       type: d.type
//     })) || [],
//     // review_of_systems: patientData.reviewofsystem?.map(ros => ({
//     //   system: ros.rosname,
//     //   findings: ros.rosvalue?.map(v => v.value).join(', ') || ""
//     // })) || [],
//     vitals: finalVitals,
//   },
//   history: {
//     medical_history: patientData.medicalhistory?.map(h => ({
//       condition: h.condition,
//       diagnosis_date: h.conditionidentifieddate
//     })) || [],
//     surgical_history: patientData.orders?.procedure?.map(p => ({
//       procedure: p.ordername,
//       order_date: p.orderdate
//     })) || []
//   },
//   hospital_course: {
//     procedures: patientData.orders?.procedure?.map(p => p.ordername) || [],
//     vaccinations: patientData.orders?.vaccinationdetail?.map(v => ({
//       vaccine: v.vaccinename,
//       date: v.admindate
//     })) || [],
//     orders: {
//       lab: patientData.orders?.lab?.map(l => l.ordername) || [],
//       imaging: patientData.orders?.imaging?.map(i => i.ordername) || []
//     }
//   },
//   instructions: [
//     ...(patientData.generalnotes?.map(note => note.generalnote) || []),
//     ...(patientData.dieticiannote?.map(note => note.dietnote) || [])
//   ],
//   follow_up_plan: {
//     follow_up_date: patientData.info?.followupdate || null,
//     instructions: patientData.doctorsassessment?.[0]?.plan || null
//   },
// };
        //existing
        // const aiInputData = {
        //   // transcription: `Discharge Summary for ${patientData.info?.patientname || "Patient"}, ${patientData.info?.patientgender || ""}, UHID ${patientData.info?.patientmrn || "N/A"}.`,
        //   // has_midoc_idp: "True",
        //   patient_info: {
        //     name: patientData.info?.patientname || "Unknown",
        //     dateOfBirth: patientData.info?.patientage || "Unknown",
        //     age: calculateAge(patientData.info?.patientage) || 0,
        //     gender: patientData.info?.patientgender || "Unknown",
        //     mrn: patientData.info?.patientmrn || null,
        //     phone: patientData.info?.patientphone || null
        //   },
        //   admission_details: {
        //     admission_date: patientData.info?.appointmentdate || null,
        //     discharge_date: null, // Not available in the data
        //     doctor: patientData.info?.drname || null,
        //     hospital: "Nizam Institute of Medical Sciences", // Extracted from medication data
        //     booking_id: patientData.info?.bookingid || null
        //   },
        //   diagnosis: patientData.doctorsassessment?.map(d => ({
        //     condition: d.diagnosis,
        //     plan: d.plan
        //   })) || [],
        //   presenting_complaints: {
        //     chief_complaint: patientData.chiefcomplaint?.chiefcomplaint || "",
        //     complaint_date: patientData.chiefcomplaint?.date || null,
        //     history_of_illness: patientData.historyofpresentillness?.map(illness => {
        //       const details = {};
        //       illness.details?.forEach(detail => {
        //         if (detail.values) {
        //           details[detail.attribute] = detail.values.map(v => v.value).join(', ');
        //         } else {
        //           details[detail.attribute] = detail.value;
        //         }
        //       });
        //       return {
        //         type: illness.type,
        //         details: details
        //       };
        //     }) || []
        //   },
        //   clinical_findings: {
        //     physical_exam: patientData.physicalexam?.flatMap(exam =>
        //       exam.physicalexam?.map(item => ({
        //         system: exam.type,
        //         finding: item.examvalue,
        //         abnormal: item.indicator === 1
        //       })) || []
        //     ) || [],
        //     review_of_systems: patientData.reviewofsystem?.map(ros => ({
        //       system: ros.rosname,
        //       findings: ros.rosvalue?.map(v => v.value).join(', ') || ""
        //     })) || [],
        //     vitals: finalVitals,
        //   },
        //   history: {
        //     medical_history: patientData.medicalhistory?.map(h => ({
        //       condition: h.condition,
        //       diagnosis_date: h.conditionidentifieddate
        //     })) || [],
        //     surgical_history: patientData.orders?.procedure?.map(p => ({
        //       procedure: p.ordername,
        //       order_date: p.orderdate
        //     })) || []
        //   },
        //   hospital_course: {
        //     procedures: patientData.orders?.procedure?.map(p => p.ordername) || [],
        //     vaccinations: patientData.orders?.vaccinationdetail?.map(v => ({
        //       vaccine: v.vaccinename,
        //       date: v.admindate
        //     })) || [],
        //     orders: {
        //       lab: patientData.orders?.lab?.map(l => l.ordername) || [],
        //       imaging: patientData.orders?.imaging?.map(i => i.ordername) || []
        //     }
        //   },
        //   instructions: [
        //     ...(patientData.generalnotes?.map(note => note.generalnote) || []),
        //     ...(patientData.dieticiannote?.map(note => note.dietnote) || [])
        //   ],
        //   follow_up_plan: {
        //     follow_up_date: patientData.info?.followupdate || null,
        //     instructions: patientData.doctorsassessment?.[0]?.plan || null
        //   },
        //   currentmedications: patientData.orders?.medication?.map(med => ({
        //     medicinename: med.medicinename,
        //     dosage: `${med.dosage} ${med.dosageunit}`,
        //     instructions: med.afterfood ? "Take after food" : med.beforefood ? "Take before food" : "As directed",
        //     interval: med.frequencytime ? `Every ${med.frequencyvalue} ${med.frequencytime}` : "As needed",
        //     duration: med.duration || null
        //   })) || [],
        //   investigations: [
        //     ...(patientData.labresults?.map(lab => ({
        //       eventtitle: lab.eventtitle,
        //       actualresultvalue: lab.actualresultvalue,
        //       resultuom: lab.resultuom,
        //       reference_range: `${lab.lower_bound || 'N/A'} - ${lab.upper_bound || 'N/A'}`,
        //       type: "lab"
        //     })) || []),
        //     ...(patientData.imagingresults?.map(img => ({
        //       eventtitle: img.reportname,
        //       actualresultvalue: img.results_interpretation?.abnormal_results || "Normal findings",
        //       resultuom: "",
        //       type: "imaging"
        //     })) || [])
        //   ],
        //   vitals: finalVitals,
        //   // vitals: Object.entries(groupedVitals).map(([name, values]) => ({
        //   //   vitalname: name,
        //   //   vitalvalue: values.join(', '),
        //   //   vitalunit: patientData.vitals?.find(v => v.vitalname === name)?.vitalunit || ""
        //   // })),
        //   doctornotes: [
        //     ...(patientData.generalnotes?.map(note => ({
        //       name: note.doctorname,
        //       notes: note.generalnote,
        //       date: note.createddate
        //     })) || []),
        //     ...(patientData.dieticiannote?.map(note => ({
        //       name: "Dietician",
        //       notes: note.dietnote,
        //       date: note.createddate
        //     })) || [])
        //   ],
        //   imaging_reports: patientData.imagingresults?.map(img => ({
        //     report_info: {
        //       name: img.reportname,
        //       type: "diagnostic",
        //       description: img.reportdescription
        //     },
        //     results_interpretation: {
        //       normal_results: img.results_interpretation?.normal_results || "",
        //       abnormal_results: img.results_interpretation?.abnormal_results || "",
        //       report_interpretation: img.results_interpretation?.report_interpretation || ""
        //     }
        //   })) || [],
        //   documents: patientData.documentdetail?.map(doc => ({
        //     name: doc.reportname,
        //     type: doc.reporttype,
        //     url: doc.documenturl ? `${doc.imagepath}${doc.documenturl}` : null
        //   })) || []
        // };

        // const aiInputData = {
        //     patient_info: {
        //         name: patientData.info?.patientname || "Unknown",
        //         dateOfBirth: patientData.info?.patientage || "Unknown",
        //         age: calculateAge(patientData.info?.patientage) || 0,
        //         gender: patientData.info?.patientgender || "Unknown"
        //     },
        //     currentmedications: patientData.orders?.medication?.map(med => ({
        //         medicinename: med.medicinename,
        //         dosage: `${med.dosage} ${med.dosageunit}`,
        //         instructions: med.afterfood ? "Take after food" : med.beforefood ? "Take before food" : "As directed",
        //         interval: med.frequencytime ? `Every ${med.frequencyvalue} ${med.frequencytime}` : "As needed"
        //     })) || [],
        //     investigations: patientData.labresults?.map(lab => ({
        //         eventtitle: lab.eventtitle,
        //         actualresultvalue: lab.actualresultvalue,
        //         resultuom: lab.resultuom
        //     })) || [],
        //     vitals: [
        //         {
        //             vitalname: "Body Temperature",
        //             vitalvalue: patientData.vitals?.find(v => v.vitalname === "Body Temperature")?.vitalvalue || "",
        //             vitalunit: "°F"
        //         },
        //         {
        //             vitalname: "Blood Pressure",
        //             vitalvalue: `${patientData.vitals?.find(v => v.vitalname === "Systolic Blood Pressure")?.vitalvalue || ""}/${patientData.vitals?.find(v => v.vitalname === "Diastolic Blood Pressure")?.vitalvalue || ""}`,
        //             vitalunit: "mmHg"
        //         },
        //         {
        //             vitalname: "Pulse",
        //             vitalvalue: patientData.vitals?.find(v => v.vitalname === "Pulse")?.vitalvalue || "",
        //             vitalunit: "bpm"
        //         }
        //     ],
        //     doctornotes: [
        //         ...(patientData.generalnotes?.map(note => ({
        //             name: note.doctorname,
        //             notes: note.generalnote
        //         })) || []),
        //         ...(patientData.dieticiannote?.map(note => ({
        //             name: "Dietician",
        //             notes: note.dietnote
        //         })) || [])
        //     ],
        //     imaging_reports: patientData.imagingresults?.map(img => ({
        //         report_info: {
        //             name: img.reportname,
        //             type: "diagnostic",
        //             description: img.reportdescription
        //         },
        //         results_interpretation: {
        //             normal_results: img.results_interpretation?.normal_results || "",
        //             abnormal_results: img.results_interpretation?.abnormal_results || "",
        //             report_interpretation: img.results_interpretation?.report_interpretation || ""
        //         }
        //     })) || [],
        //     clinical_findings: {
        //         chief_complaint: patientData.chiefcomplaint?.chiefcomplaint || "",
        //         history_of_illness: patientData.historyofpresentillness?.map(illness => {
        //             if (illness.type === "pain") {
        //                 const site = illness.details.find(d => d.attribute === "Site")?.values?.[0]?.value;
        //                 const severity = illness.details.find(d => d.attribute === "Rating Scale")?.value;
        //                 return `${site} pain (Severity: ${severity}/10)`;
        //             }
        //             return illness.type;
        //         }) || [],
        //         physical_exam: patientData.physicalexam?.flatMap(exam => 
        //             exam.physicalexam?.map(item => item.examvalue) || []
        //         ) || [],
        //         medical_history: patientData.medicalhistory?.map(h => `${h.condition} (diagnosed ${new Date(h.conditionidentifieddate).getFullYear()})`) || []
        //     }
        // };

        setPatientIpdData(aiInputData)
        // console.log('Structured AI Input Data:', aiInputData);
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    // editProfileModal.current.openModal();
    // navigate(url)
    dismissLoader()
  };

  useEffect(() => {
    (async () => {
      const currentUrl = window.location.href;
      const searchParams = new URLSearchParams(currentUrl.split('?')[1]);
      const id = searchParams.get('patientId');
      const apmtid = searchParams.get('appointmentId');
      const docid = searchParams.get('doctId');
      const dischargeType = searchParams.get('type');
      // console.log(dischargeType, 'dischargeType')
      setPatientDischargeType(dischargeType);
      setPatientid(id);
      setAppointmentid(apmtid);
      setDoctrId(docid);

      // Ensure doctors are loaded first so we can resolve referral doctor properly
      await fetchDoctors(docid);

      if (dischargeType) {
        await fetchIpdPatientData(id, apmtid, docid);
      }

      if (apmtid) {
        fetchpatientdata(id, apmtid)
        FetchHospitals()
      } else {
        fetchpatientdata(id, "")
      }
    })();
  }, [])
  // existing useEffect
  // useEffect(() => {
  //   // const getDischargeSummaryStatus = localStorage.getItem("saveDischarge");
  //   // if (getDischargeSummaryStatus !== null) {
  //   //   setDischargeSummary(getDischargeSummaryStatus);
  //   // }

  //   const currentUrl = window.location.href;
  //   const searchParams = new URLSearchParams(currentUrl.split('?')[1]);
  //   const id = searchParams.get('patientId');
  //   const apmtid = searchParams.get('appointmentId');
  //   const docid = searchParams.get('doctId');
  //   const dischargeType = searchParams.get('type');
  //   console.log(dischargeType, 'dischargeType')
  //   setPatientDischargeType(dischargeType);
  //   setPatientid(id);
  //   setAppointmentid(apmtid);
  //   setDoctrId(docid);
  //   fetchDoctors(docid)

  //   if (dischargeType) {
  //     fetchIpdPatientData(id, apmtid, docid);
  //   }

  //   if (apmtid) {
  //     fetchpatientdata(id, apmtid)
  //     FetchHospitals()
  //   } else {
  //     fetchpatientdata(id, "")
  //   }
  // }, [])

    const fetchpatientdata = async (id, apmtid = "") => {
      setPatienData(null)
      try {
        const result = await FetchPatientDetails({
          patientid: id,
          ...(apmtid && { appointmentid: apmtid }),
          ...(apmtid && { type: 'ipd' })
        });
        if (result != null) {
          setPatienData(result);
          // console.log('Patient Data:', result);
        } else {
          console.log('Patient Data else result:', result);
          setPatienData(null)
        }
        return result;
      } catch (error) {
        console.error("Error in home:", error);
      }
  };

  const formatDate = (dateString) => {
      if (!dateString) return "-";
      return moment(dateString).format("Do MMM, YYYY");
    };

  const formatTime = (time) => {
    if (!time) {
      return "";
    }

    const [hours, minutes] = time.split(':');

    const date = new Date();
    date.setHours(hours, minutes);

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return formattedTime;
  };
  const handleUploadDocument = async (e) => {
    e.preventDefault();
    const files = Array.from(e.target.files); // Convert FileList to an array

    if (!files.length) {
      console.error("No files selected");
      return;
    }

    let previewFiles = [];

    // if (dischargeSummary && dischargeSummary == 1) {
      // MULTIPLE FILE SELECTION (No API Call Here)
      for (let file of files) {
        const reader = new FileReader();
        reader.onloadend = () => {
          previewFiles.push({ name: file.name, url: reader.result, type: file.type });
          // Update state only after all files are processed
          if (previewFiles.length === files.length) {
            setSelectedImages([...previewFiles]); // Store previews
          }
        };
        reader.readAsDataURL(file);
      }
    // } 
    // else {
    //   // SINGLE FILE UPLOAD
    //   const file = files[0];
    //   const reader = new FileReader();

    //   reader.onloadend = () => {
    //     const base64Data = reader.result.split(",")[1];
    //     setSelectedImages([{ name: file.name, url: reader.result, type: file.type }]); // Store single file
    //     setAIInput({ data: base64Data });
    //     //handleUploadBase();

    //   };

    //   reader.readAsDataURL(file);
    //   // const result = await uploadImageCommonFunction(file, file.name);

    //   //     const allowedTypes = ["application/pdf"];
    //   //     // const maxSizeInMB = 5;
    //   //     // const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    //   //     const documenturl = result.name;

    //   //     if (result) {
    //   //       setPdfUrl(documenturl);
    //   //     }
    // }
    setDocUpload(false);
    setPreviewDoc(true);
    setHideMobile(true)
  };
  const generate16DigitGUID = () => {
    return 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () =>
      Math.floor(Math.random() * 16).toString(16)
    ).toUpperCase();
  };
  const handleUploadFiles = async () => {
    if (!selectedImages || !selectedImages.length) {
      console.error("No files selected for upload");
      return;
    }
    let uploadedFileNames = [];

    for (let file of selectedImages) {
      try {
        // Convert base64 or URL back to Blob/File (if necessary)
        let fileToUpload;

        if (file.url.startsWith("data:")) {
          // Convert base64 to File
          const byteString = atob(file.url.split(",")[1]);
          const mimeType = file.type;
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const intArray = new Uint8Array(arrayBuffer);

          for (let i = 0; i < byteString.length; i++) {
            intArray[i] = byteString.charCodeAt(i);
          }

          fileToUpload = new File([intArray], file.name, { type: mimeType });
        } else {
          // If the file was uploaded from input (already a File object)
          fileToUpload = new File([file], file.name, { type: file.type });
        }

        // Upload the file
        const response = await uploadImageCommonFunction(fileToUpload, fileToUpload.name);

        if (response) {
          uploadedFileNames.push(response.name);
        } else {
          console.error(`Failed to upload ${file.name}`);
        }
      } catch (error) {
        console.error(`Error processing file ${file.name}:`, error);
      }
    }
    let blobURL = "";
    var doctorDetails = localStorage.getItem("LoginInfo");
    if (doctorDetails) {
      var formateddata = JSON.parse(doctorDetails);
      blobURL = formateddata.imagepath;
    }

    let input = {
      guid: generate16DigitGUID(),
      "type": "multi",
      "baseapiurl": CONFIG.APIBaseUrl,
      documents: uploadedFileNames.map(fileName => ({ url: blobURL + fileName })) // Convert filenames to objects with `url` key
    };
    showLoader();
    try {
      const result = await SaveSummaryCallLog(input);
      if (result) {
        const resp = await UploadFiletoFetchSummary(input);
        setShowThanksScreen(true);
      } else {
        showErrorToast("Something went wrong");
      }
      dismissLoader();
    } catch (error) {
      console.error("API Error:", error);
    }
    // Store uploaded filenames in state
    setPdfUrl([...uploadedFileNames]);
    if (screenType === "mobile") {
      setHideMobile(false)
    }
  };
  // Remove a selected file from preview
  const handleRemoveFile = (fileName) => {
    setSelectedImages(selectedImages.filter(file => file.name !== fileName));
  };

  const handleUploadBase = async () => {
    if (!isChatbotAllowed()) {
      showErrorToast("Please upgrade your subscription to use AI features");
      return;
    }

    showLoader();
    try {
      const result = await uploadPdfBaseURL(AIInput);
      if (result && result?.content) {
        setData(result.content)
        setDocUpload(false)
        setPreviewDoc(false);
        setHideMobile(false);
        handleLogcall();
      } else {
        setData(null)
        showErrorToast("Something went wrong");
      }
      dismissLoader();
    } catch (error) {
      console.error("API Error:", error);
    }
    if (screenType === "mobile") {
      setHideMobile(false)
    }
  };
  const handleLogcall = async () => {
    let input = {
      'uploadedpdf': null, //pdfUrl,
      "issingledocument": "1"
    }
    try {
      const result = await SaveSummaryCallLog(input);

      if (result && result.output.result === 'Success') {
        setDownloadSummaryId(result.output.id);
        showSuccessToast("Document uploaded successfully");
        console.log(screenType, 'check screen type')
        if (screenType === "mobile") {
          setHideMobile(false)
        }
      }

    } catch (error) {
      console.error("API Error:", error);
    }
  };
  // const downloadSummary = () => {
  //   let content = "<html><head><meta charset='utf-8'></head><body>";
  // data.forEach(item => {
  //   content += `<h3>${item.header}</h3><p>${item.text.replace(/\n/g, "<br>")}</p>`;
  // });
  // content += "</body></html>";

  // const encodedContent = encodeURIComponent(content);
  // const a = document.createElement("a");
  // a.href = "data:application/msword;charset=utf-8," + encodedContent;
  // a.download = "summary.docx";
  // document.body.appendChild(a);
  // a.click();
  // document.body.removeChild(a);
  // };
  const downloadSummary = async () => {
    try {
      let content = `<html>
        <head>
          <meta charset='utf-8'>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; text-align: left; }
            h1 { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px; }
            h3 { font-size: 16px; font-weight: bold; }
            p { font-size: 14px; }
          </style>
        </head>
        <body>
          <h1>Patient Discharge Summary Report</h1>`;

      data.forEach(item => {
        content += `<h3>${item.header}</h3><p>${item.text.replace(/\n/g, "<br>")}</p>`;
      });

      content += `</body></html>`;

      const encodedContent = encodeURIComponent(content);
      const a = document.createElement("a");
      a.href = "data:application/msword;charset=utf-8," + encodedContent;
      a.download = "discharge-summary.doc";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

          // Get audiourl from localStorage (set by CPU-transcription.js)
    // const dischargeAudioUrl = localStorage.getItem("dischargeAudioUrl");
    // console.log('dischargeAudioUrl: ', dischargeAudioUrl)

      // Convert the HTML content to a Blob (for .doc file)
      // if (dischargeSummary && dischargeSummary == 1) {
        const blob = new Blob([content], { type: 'application/msword' });
        const file = new File([blob], 'discharge-summary.doc', { type: 'application/msword' });

        // Upload the .doc file
        const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.doc');
        const documenturl = uploadResponse.name;
        if (uploadResponse) {
          setDocUrl(documenturl);
        } else {
          setDocUrl('');
        }

        const handleDownloadSummary = async () => {
          showLoader();
          const input = {
            'id': downloadSummaryId,
            'downloadedpdf': docUrl && docUrl != "" ? docUrl : documenturl,
            'type': 'update',
            // ADD audiourl if available
          // ...(dischargeAudioUrl && { audiourl: dischargeAudioUrl })
          }
          try {
            const result = await SaveSummaryCallLog(input);
            if (result && result.output.result === 'Success') {
              showSuccessToast("Document downloaded successfully");
            }
          } catch (error) {
            console.error("API Error:", error);
          }
          dismissLoader();
        };

        handleDownloadSummary();
      // }

      navigate("/home")
    } catch (error) {
      console.error("Error in downloadSummary:", error);
      showErrorToast("Failed to download the document");
    }
  };

  const sendEmail = () => {
    const recipient = doctoremail; // Replace with actual recipient

    let content = `PATIENT DISCHARGE SUMMARY REPORT\n\n`;

    data.forEach(item => {
      content += `${item.header.toUpperCase()}:\n${item.text}\n\n`;
    });

    const subject = encodeURIComponent("Patient Discharge Summary Report");
    const body = encodeURIComponent(content);

    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}&su=${subject}&body=${body}`, "_blank");
  };
  const handlechangetext = (text, index) => {
    const newData = [...data];
    newData[index].text = text;
    setData(newData);
  }

  const isChatbotAllowed = () => {
    const subscriptionName = localStorage.getItem("subscriptionName");
    const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");

    // If either value is missing, assume chatbot is allowed (or you can handle differently)
    if (!subscriptionName || !subscriptionEndDate) return true;

    // Check if subscription is Basic and end date has passed
    const currentDate = new Date();
    const endDate = new Date(subscriptionEndDate);

    // return !(subscriptionName === "Basic");
    return !(subscriptionName === "Basic" && currentDate > endDate);
  };

  //-------------------------AIRA Notes Transcription
  const airaTranscribeNotes = useRef(null);
  const ipdTranscribeNotes = useRef(null);
  const useGPUChatbot = !!navigator.gpu;

  const [ipdClicked, setIpdClicked] = useState('');

  const audioCompatibilityDemo = useRef(null);

  const handleAIRANotesClick = () => {
    if (patientDischargeType) {
      setIpdClicked('RecordOnly')
    }
    if (!useGPUChatbot) {
      // Case 1: If useGPUChatbot is false
      airaTranscribeNotes.current.openModal();
    } else {
      // Case 2: If useGPUChatbot is true
      const capableGPU = localStorage.getItem("capableGPU");
      console.log("capableGPU is set to", capableGPU);

      // newly added block
      if (capableGPU === null || capableGPU === "false") {
      // Do NOT trigger audioCompatibilityDemo if "false"
      airaTranscribeNotes.current.openModal();
      } else {
        airaTranscribeNotes.current.openModal();
      }

      // existing block of code
      // if (capableGPU === null) {
      //   // If capableGPU does not exist
      //   audioCompatibilityDemo.current.openModal();
      // } else {
      //   // If capableGPU exists (either "true" or "false")
      //   airaTranscribeNotes.current.openModal();
      // }
    }
  };

  const handleAIRAIPDNotesClick = () => {
    setIpdClicked('IPDRecord')
    if (!useGPUChatbot) {
      // Case 1: If useGPUChatbot is false
      airaTranscribeNotes.current.openModal();
    } else {
      // Case 2: If useGPUChatbot is true
      const capableGPU = localStorage.getItem("capableGPU");
      console.log("capableGPU is set to", capableGPU);
      // newly added block
      if (capableGPU === null || capableGPU === "false") {
      // Do NOT trigger audioCompatibilityDemo if "false"
      airaTranscribeNotes.current.openModal();
      } else {
        airaTranscribeNotes.current.openModal();
      }

      // existing block of code
      // if (capableGPU === null) {
      //   // If capableGPU does not exist
      //   audioCompatibilityDemo.current.openModal();
      // } else {
      //   // If capableGPU exists (either "true" or "false")
      //   airaTranscribeNotes.current.openModal();
      // }
    }
  };

  // Only IPD Data
  const handleIPDDataClick = () => {
    setIpdClicked('IPD')
    ipdTranscribeNotes.current.openModal();
  };

  const handledatechange = (selectedDate) => {
    const formattedDate = format(selectedDate, "yyyy-MM-dd");
    setDate(formattedDate);
  };

  const dischargeDateChange = (selectedDate) => {
    const formattedDate = format(selectedDate, "yyyy-MM-dd");
    setDischargeDate(formattedDate);
  };

  const handleTimeChange = (event) => {
    const inputTime = event.target.value;
    const currentTime = new Date();
    const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
  
    const inputDate = new Date();
    inputDate.setHours(inputHours);
    inputDate.setMinutes(inputMinutes);
  
    if (inputDate > currentTime) {
      
      setTime(moment().format("HH:mm"));
      showErrorToast("Future time cannot be selected.");
    } else {
      setTime(inputTime);
    }
  };


  const handleDischargeNotes = async () => {
    const inputToSave = {
      input: {
        // doctorid: doctorId,
        patientid: patientid,
        appointmentid: appointmentid,
        completed: "3",
        dischargedate: `${moment(dischargeDate, "DD-MM-YYYY").format("YYYY-MM-DD")}T${time}:00`,
        discharge_type: dischargeType !== "other" ? dischargeType : dischargeTypeText,
        "followup": {
          "isfollowup": 1,
          "followupdate": moment(date, "DD-MM-YYYY").format("YYYY-MM-DD"),
          "isfreevisit": 0,
          "referraldoctor": DefaultDoctor ? `${DefaultDoctor}` : "",
          "referraltohighercenters": referralCenter ? referralCenter : ''
          // existing
          // "referraldoctor": DefaultDoctor && referralCenter ? `${DefaultDoctor}, ${referralCenter}` : DefaultDoctor || referralCenter,
        }
      },
    };

    try {
      const result = await DischargePatient(inputToSave.input);
      if(result?.output?.result == 'success'){
        // fetchpatientdata(patientid)
        fetchIpdPatientData(patientid, appointmentid, doctrId)
        showSuccessToast('Patient Discharge details Updated')
        setIsSavedDischarge(true)
        dischargePatientModal.current.closeModal();
      }
      // return result;
    } catch (error) {
      console.error("Error in Add Doctor Notes:", error);
      throw error;
    }
  };

    const fetchDoctors = async (docIdParam = null) => {
    showLoader();
    try {
      const result = await FetchUsersByClinic({
        doctrId,
        appointmentid
      });
      if (result.output.result == "success") {
        const doctors = result.output.data;
        setDoctorData(doctors);
        const doctorNames = doctors.map((step) => step.fullname);
        // console.log('doctorNames: ', doctorNames)
        // console.log('doctrId being searched: ', doctrId);
        // console.log('all doctor IDs: ', doctors.map(doc => ({id: doc.doctorid, name: doc.fullname})));
        setDoctorList(doctorNames);

        // Determine which doctor id to use to preselect — prefer docIdParam (from URL) if provided
          const targetId = docIdParam ?? doctrId;
          const currentDoctor = doctors.find(doc => Number(doc.doctorid) === Number(targetId));
          // console.log('currentDoctor: ', currentDoctor)
          if (currentDoctor) {
            setDefaultDoctor(currentDoctor.fullname);
          }
          dismissLoader();
        return doctors;
          // // if (shouldSetDefault) {
          // const currentDoctor = doctors.find(doc => doc.doctorid == doctrId);
          // console.log('currentDoctor: ', currentDoctor)
          // if (currentDoctor) {
          //   // setDefaultDoctor(currentDoctor);
          //   setDefaultDoctor(currentDoctor.fullname);
          // } 
        // }
      } else {
        setDoctorList([]);
        dismissLoader();
        return [];
      }
      dismissLoader();
    } catch (error) {
      console.error("Error", error);
      dismissLoader();
      return [];
    }
  };

  const HandleEditDoctor = (selectedOption)=>{
    // selectedOption is fullname string; find the matching doctor object
    const selectedDoctor = doctorData.find(doctor => doctor.fullname === selectedOption);
    if (selectedDoctor) {
      setDefaultDoctor(selectedDoctor.fullname);
    } else {
      setDefaultDoctor(null);
    }
    // let selectedDoctor = doctorData.filter(doctor => doctor.fullname == selectedOption);
    // console.log(selectedOption, "selected doctor");
    // if (selectedDoctor.length > 0) {
    //   console.log(selectedDoctor, "doctor");
    //   setDefaultDoctor(selectedDoctor[0].fullname);
    // } else {
    //   setDefaultDoctor(null);
    // }
  }
//   const HandleEditDoctor = (selectedOption) => {
//   const selectedDoctor = doctorData.find(doctor => doctor.fullname === selectedOption);
//   if (selectedDoctor) {
//     setDefaultDoctor(selectedDoctor);
//   } else {
//     setDefaultDoctor(null);
//   }
// };

  //  Referring to higher centers-----------------------------------------
   const [referralHospitalList, setReferralHospitalList] = useState([]);
   const [referralCenter, setReferralCenter] = useState("");
   
   const hospitalChange = (e) => {
      setReferralCenter(e.target.value);
    };
    const handleHospitalChange = (value) => {
      setReferralCenter(value);
    };
    const FetchHospitals = async() => {
      const fetchHospitalsInput = {
        doctorid: getLoginID()
      }
      showLoader();
      try{
        const result = await fetchReferredHospital(fetchHospitalsInput);
        // console.log('resutl: ', result)
        if(result && result.output.result === 'success' && result.output.data) {
          const response = result.output.data;
          const list = response?.map((item) => item.hospitalname)
          setReferralHospitalList(list)
        }else {
          setReferralHospitalList([])
        }
        dismissLoader()
      } catch(error) {
        console.error('Error in fetching the hospitals: ', error);
        throw error;
      }
    }

  return (
    <>
      {screenType === "web" ? (
        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            {isLoading && <Loader />}
            <Box w="calc(100vw - 6.25rem)" bg='#f1f1f1f1' display="flex" flexDir="column">
              <SecondaryNav
                // withBack="Discharge Summary Notes"
                withBack={patientDischargeType ? 'IPD Discharge Summary Notes' : "Discharge Summary Notes"}
                goBack={() => patientDischargeType ? navigate("/ipdpatients") : navigate("/home")}
              />

              <Flex
                h="calc(100vh - 75px)"
                // minH="fit-content"
                w="100%"
                justifyContent="center"
                // alignItems="center"
                alignItems="flex-start"
                overflow='hidden auto'
                p={docUpload ? "5rem" : "0"}
              >
                {/* {hideSection && (<> */}
                {docUpload && (<>
                  {/* <Flex flexDir="column" h='100%' bg='white' justifyContent={appointmentid ? "" : "center"} borderRadius='12px' boxShadow={COLORS.BOX_SHADOW_LIGHT} gap="15px" w="70%"> */}
                  <Flex flexDir="column" minH="fit-content" bg='white' justifyContent={appointmentid ? "" : "center"} borderRadius='12px' boxShadow={COLORS.BOX_SHADOW_LIGHT} gap="15px" w="70%">
                    {/* Patinet details start*/}
                    {appointmentid && (
                      <Flex w='100%' flexDir='column'>
                          <Flex p='2rem 0 0 2rem'>
                            <Text fontSize="lg" fontWeight='600' display="flex" alignItems="center" gap="2">
                              <MdOutlineMedicalInformation />
                              Patient Details
                            </Text>
                          </Flex>
                          <Flex w='100%' p='2rem' py='1rem' gap='.75rem'>
                            <Box display="flex" alignItems="center" gap="0.5rem">
                            <FaRegUser /> 
                            <Text fontSize="1rem" fontWeight="600">
                              {`${patienData?.patientinfo?.firstname}  ${patienData?.patientinfo?.lastname}`}
                            </Text>
                            </Box>
                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/gender.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                {
                                  patienData?.patientinfo?.gender
                                    ? patienData?.patientinfo?.gender.charAt(0).toUpperCase() +
                                    (patienData?.patientinfo?.gender.length > 1 ? patienData?.patientinfo?.gender.slice(1).toLowerCase() : 'N/A')
                                    : '-'
                                }
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image ml='4px' src="/assets/svgs/height.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="1rem">
                                {patienData?.patientinfo?.height ? (patienData?.patientinfo?.height + " " + patienData?.patientinfo?.heightunit) : ('N/A')}
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/weight.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                {patienData?.patientinfo?.weight ? (patienData?.patientinfo?.weight + " " + patienData?.patientinfo?.weightunit) : ('N/A')}
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/cake.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                {patienData &&
                                  patienData.patientinfo &&
                                  patienData?.patientinfo?.dob
                                  ? (`${patienData?.patientinfo?.dob} ${calculateAgeCommonFunc(patienData?.patientinfo?.dobDbFormat)}`)
                                  : "N/A"}
                              </Text>
                            </Box>
                          </Flex>
                          <Divider />
                      </Flex>
                    )}
                    {/* Patinet details end */}
                    <Flex
                      mx="auto"
                      mb={3}
                      w="fit-content"
                      align="center"
                      justify="center"
                      flexDir="column"
                      p='3rem 0.5rem'
                      pb='0'
                    >
                      <Box display="flex" mb={3} alignItems="center" justifyContent="center" p={4} border='1px solid #e2e2e2' borderRadius="full">
                        <Image src="/assets/svgs/reports-filled.svg" boxSize='25px' />
                      </Box>
                      <Heading as="h2" fontSize="2xl" fontWeight="bold" color="gray.800" mb={2}>
                        Create Discharge Summary
                      </Heading>
                      <Text color="gray.600" fontSize='0.875rem'>
                        Generate comprehensive discharge notes using AI/Voice/Notes
                      </Text>
                    </Flex>

                    <Input
                        type="file"
                        accept=".pdf,.png,.jpg,.docx,.doc"
                        //accept=".pdf"
                        hidden
                        id="uploaddocument"
                        multiple
                        onChange={(e) => handleUploadDocument(e)}
                      />
                    {/* {dischargeSummary == 1 ? (
                      <Input
                        type="file"
                        accept=".pdf,.png,.jpg,.docx,.doc"
                        //accept=".pdf"
                        hidden
                        id="uploaddocument"
                        multiple
                        onChange={(e) => handleUploadDocument(e)}
                      />
                    ) : (
                      <Input
                        type="file"
                        //accept=".pdf,.png,.jpg,.docx,.doc"
                        accept=".pdf"
                        hidden
                        id="uploaddocument"
                        onChange={(e) => handleUploadDocument(e)}
                      />
                    )} */}

                    {!patientDischargeType && (
                      <Box
                        as="button"
                        flexDir="column"
                        justifyContent="center"
                        alignItems="center"
                        w="calc(100% - 25%)"
                        mx='auto'
                        p="20px"
                        gap="8px"
                        border="1px dashed #CDCFD4"
                        borderRadius="12px"
                        onClick={handleuploadDocumentAttachment}

                      >
                        <Image
                          w="20px"
                          m="auto"
                          mb="10px"
                          h="auto"
                          src="/assets/svgs/file-upload.svg"
                        />
                        <Text fontSize="14px" color="#163E9E" fontWeight="600">
                          Drop files here
                        </Text>
                        <Text fontWeight="400" fontSize="12px" color="#6A707D">
                          {/* PDF (max. 5mb) */}
                          PDF, DOC, PNG, JPG (max. 5mb)
                        </Text>
                        {/* {dischargeSummary == 1 ? (
                          <Text fontWeight="400" fontSize="12px" color="#6A707D">
                            PDF, DOC, PNG, JPG (max. 5mb)
                          </Text>
                        ) : (
                          <Text fontWeight="400" fontSize="12px" color="#6A707D">
                            PDF (max. 5mb)
                          </Text>
                        )} */}
                      </Box>
                    )}

                    {patientDischargeType && (
                      <>
                        <Box w='100%' display='flex' justifyContent='center' pb='1.5rem'>
                          <Box
                            as="button"
                            borderRadius="md"
                            onClick={isChatbotAllowed() ? handleIPDDataClick : null}
                            zIndex="5"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            gap="5px"
                            // w="100px"
                            w='50%'
                            p='0 10px'
                            h="2.5rem"
                            // mr={"4px"}
                            // ml="0.75rem"
                            left={{ lg: "80%", xl: "80%" }}
                            backgroundImage={isChatbotAllowed() ?
                              "linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)" :
                              "linear-gradient(to right top, #6b6b6b, #5f5f5f, #545454, #484848, #3d3d3d)"}
                            opacity={isChatbotAllowed() ? 1 : 0.7}
                            cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                            _hover={isChatbotAllowed() ? {
                              backgroundImage: "linear-gradient(to right top, #0a6a46, #00646b, #005b83, #004d95, #0d3a85)"
                            } : {}}
                            title={!isChatbotAllowed() ? "Please upgrade your subscription to use this feature" : ""}
                          >
                            {/* <Image w="16px" src="/assets/imgs/white-spark.png" opacity={isChatbotAllowed() ? 1 : 0.5}  /> */}
                            <Image w="12px" mr='.5rem' src="/assets/svgs/reports-filled.svg" filter={COLORS.FILTER_WHITE} opacity={isChatbotAllowed() ? 1 : 0.5} />
                            <Box display="flex" flexDir="column">
                              <Text
                                textAlign="left"
                                fontSize="0.875rem"
                                fontWeight="700"
                                color="white"
                              >
                                Generate Summary
                              </Text>
                            </Box>
                            <Flex bg='#ffffff52' ml='3' borderRadius='4px' p='1px 5px' alignItems='center' justifyContent='center'>
                              <Text fontSize='12px' color='white'>AI Powered</Text>
                            </Flex>
                          </Box>
                        </Box>
                        {/* <Flex w='100%' justifyContent='center' alignItems='center'>
                          <Flex gap='0.75rem' w='50%' alignItems='center'>
                            <Divider opacity='1' />
                            <Text textAlign='center' fontSize='14px' fontWeight='600'>OR</Text>
                            <Divider opacity='1' />
                          </Flex>
                        </Flex>
                        <Box w='100%' display='flex' justifyContent='center'>
                          <Box
                            as="button"
                            borderRadius="md"
                            onClick={isChatbotAllowed() ? handleAIRAIPDNotesClick : null}
                            zIndex="5"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            gap="5px"
                            w='50%'
                            p='0 10px'
                            h="2.5rem"
                            left={{ lg: "80%", xl: "80%" }}
                            backgroundImage={isChatbotAllowed() ?
                              "linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)" :
                              "linear-gradient(to right top, #6b6b6b, #5f5f5f, #545454, #484848, #3d3d3d)"}
                            opacity={isChatbotAllowed() ? 1 : 0.7}
                            cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                            _hover={isChatbotAllowed() ? {
                              backgroundImage: "linear-gradient(to right top, #0a6a46, #00646b, #005b83, #004d95, #0d3a85)"
                            } : {}}
                            title={!isChatbotAllowed() ? "Please upgrade your subscription to use this feature" : ""}
                          >
                            <Box display='flex' mr='5px' alignItems='center' justifyContent='center' gap='0.5rem'>
                              <Image w="12px" src="/assets/svgs/un-mute.svg" filter={COLORS.FILTER_WHITE} opacity={isChatbotAllowed() ? 1 : 0.5} />
                              <Text color='white' mt='-4px'>+</Text>
                              <Image w="12px" src="/assets/svgs/reports-filled.svg" filter={COLORS.FILTER_WHITE} opacity={isChatbotAllowed() ? 1 : 0.5} />
                            </Box>
                            <Box display="flex" flexDir="column">
                              <Text
                                textAlign="left"
                                fontSize="0.875rem"
                                fontWeight="700"
                                color="white"
                              >
                                Record & Generate Summary
                              </Text>
                            </Box>
                            <Flex border='1px solid #ffffff52' ml='3' borderRadius='4px' p='1px 5px' alignItems='center' justifyContent='center'>
                              <Text fontSize='12px' color='white'>Voice + AI</Text>
                            </Flex>
                          </Box>
                        </Box> */}
                      </>
                    )} 

                    {/* <Flex w='100%' justifyContent='center' alignItems='center'>
                      <Flex gap='0.75rem' w='50%' alignItems='center'>
                        <Divider opacity='1' />
                        <Text textAlign='center' fontSize='14px' fontWeight='600'>OR</Text>
                        <Divider opacity='1' />
                      </Flex>
                    </Flex>

                    <Box w='100%' display='flex' justifyContent='center'>
                      <Box
                        as="button"
                        borderRadius="md"
                        onClick={isChatbotAllowed() ? handleAIRANotesClick : null}
                        zIndex="5"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap="5px"
                        w='50%'
                        h="2.5rem"
                        left={{ lg: "80%", xl: "80%" }}
                        backgroundImage={isChatbotAllowed() ?
                          "linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)" :
                          "linear-gradient(to right top, #6b6b6b, #5f5f5f, #545454, #484848, #3d3d3d)"}
                        opacity={isChatbotAllowed() ? 1 : 0.7}
                        cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                        _hover={isChatbotAllowed() ? {
                          backgroundImage: "linear-gradient(to right top, #0a6a46, #00646b, #005b83, #004d95, #0d3a85)"
                        } : {}}
                        title={!isChatbotAllowed() ? "Please upgrade your subscription to use this feature" : ""}
                      >
                        <Image w="12px" src="/assets/svgs/un-mute.svg" filter={COLORS.FILTER_WHITE} opacity={isChatbotAllowed() ? 1 : 0.5} />
                        <Box display="flex" flexDir="column">
                          <Text
                            textAlign="left"
                            fontSize="0.875rem"
                            fontWeight="700"
                            color="white"
                          >
                            Record
                          </Text>
                        </Box>
                        <Flex border='1px solid #ffffff52' ml='3' borderRadius='4px' p='1px 5px' alignItems='center' justifyContent='center'>
                          <Text fontSize='12px' color='white'>Voice Notes</Text>
                        </Flex>
                      </Box>
                    </Box> */}
                  </Flex>
                  {appointmentid && (
                  <Flex flexDir="column" justifyContent='space-between' h='100%' px='0.75rem' gap="0.75rem">
                      {/* <Box display="flex" w='100%' bg='white' p='1.25rem' borderRadius='12px' boxShadow={COLORS.BOX_SHADOW_LIGHT} flexDirection="column">
                        <Box display='flex' flexDir='column' gap='0.5rem'>
                          <Box display='flex' flexDir='column' gap='0.25rem'>
                            <Text fontSize="1rem" fontWeight="600">
                              {`${patienData?.patientinfo?.firstname}  ${patienData?.patientinfo?.lastname}`}
                            </Text>
                          </Box>
                          <Flex flexDir='column' w='100%' gap='8px'>
                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/gender.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                {
                                  patienData?.patientinfo?.gender
                                    ? patienData?.patientinfo?.gender.charAt(0).toUpperCase() +
                                    (patienData?.patientinfo?.gender.length > 1 ? patienData?.patientinfo?.gender.slice(1).toLowerCase() : 'N/A')
                                    : '-'
                                }
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image ml='4px' src="/assets/svgs/height.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="1rem">
                                {patienData?.patientinfo?.height ? (patienData?.patientinfo?.height + " " + patienData?.patientinfo?.heightunit) : ('N/A')}
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/weight.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                {patienData?.patientinfo?.weight ? (patienData?.patientinfo?.weight + " " + patienData?.patientinfo?.weightunit) : ('N/A')}
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/cake.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                {patienData &&
                                  patienData.patientinfo &&
                                  patienData?.patientinfo?.dob
                                  ? (`${patienData?.patientinfo?.dob} ${calculateAgeCommonFunc(patienData?.patientinfo?.dobDbFormat)}`)
                                  : "N/A"}
                              </Text>
                            </Box>
                          </Flex>
                        </Box>
                      </Box> */}

                      {/* Medical Information */}
                      {/* <Card shadow="lg" w='100%' border="0" borderRadius='12px' bg="white" h='100%' backdropFilter="blur(8px)"> */}
                      <Card shadow="lg" w='100%' border="0" borderRadius='12px' bg="white" minH="fit-content" backdropFilter="blur(8px)">
                        <CardHeader pb='0'>
                          <Text fontSize="lg" fontWeight='600' display="flex" alignItems="center" gap="2">
                            <Image src="/assets/svgs/doctors.svg" />
                            In-Patient Information
                          </Text>
                        </CardHeader>

                        <CardBody pt='3'>
                          <Box spacing="2">
                            {/* Admitted Date */}
                            <Box>
                              <FormLabel htmlFor="admitted-date" mb='0' fontSize="sm" fontWeight="medium" color="gray.700">
                                Admitted Date
                              </FormLabel>
                              <Box display="flex" alignItems="center" gap="2">
                                <Image src="/assets/svgs/home-calendar.svg" />
                                <Text color="gray.600" fontSize='0.875rem'>{patienData?.patientinfo?.admindate ? formatDate(patienData.patientinfo.admindate) : "N/A"}</Text>
                              </Box>
                            </Box>

                            {/* Attending Doctor */}
                            <Box mt="2">
                              <FormLabel htmlFor="attending-doctor" mb='0' fontSize="sm" fontWeight="medium" color="gray.700">
                                Consultant Doctor
                              </FormLabel>
                              <Box display="flex" alignItems="center" gap="2">
                                <SlUser size='14px' />
                                <Text color="gray.600" fontSize='0.875rem'>{patienData?.patientinfo?.doctorassignedname ? patienData?.patientinfo?.doctorassignedname : "N/A"}</Text>
                              </Box>
                            </Box>

                            <Divider mt="2" />

                            {/* Discharge Date & Time */}
                            <Box mt="2">
                              <FormLabel htmlFor="discharge-date" fontSize="sm" fontWeight="medium" color="gray.700">
                                Discharge Date & Time
                                <EditIcon boxSize="3" ml='2' color="gray.400" />
                              </FormLabel>
                              <Flex>
                                <DatePicker
                                  onDateChange={(selectedDateValue) =>
                                    dischargeDateChange(selectedDateValue)
                                  }
                                  defaultDate={dischargeDate}
                                  disableFutureDates={true}
                                  placeholderProp="Date"
                                  calendarStlye={{left: "-18px",  right: "unset",top:'-340px'}}
                                  datePickerInputStyle={{borderRadius: '12px 0 0 12px'}}
                                />

                                <PrimaryInput
                                  variant="fullRight"
                                  id="vitaltime"
                                  inputType="time"
                                  inputPlace="Time"
                                  pr="10px"
                                  defaultValue={time}
                                  inputValue={time}
                                  onChange={handleTimeChange }
                                />
                              </Flex>
                            </Box>

                            {/* Follow-up Doctor */}
                            <Box mt="2">
                              <FormLabel htmlFor="followup-doctor" fontSize="sm" fontWeight="medium" color="gray.700">
                                Follow-up Doctor
                                <EditIcon boxSize="3" ml='2' color="gray.400" />
                              </FormLabel>
                               <DropdownInput
                                  variant="fullSide"
                                  dropDownPlace="Doctor Name"
                                  options={DoctorList}
                                  id="followup-doctor"
                                  onClick={HandleEditDoctor}
                                  value={DefaultDoctor || ""}
                                  // value={doctorNotesData || DefaultDoctor}
                                  // defaultOption={DefaultDoctor || ""}
                                  menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                                  inputStyleCss={{w: "100%"}}
                                />
                            </Box>
                            
                            {/* Follow-up Date */}
                            <Box mt="2">
                              <FormLabel htmlFor="followup-date" fontSize="sm" fontWeight="medium" color="gray.700">
                                Follow-up Date
                                <EditIcon boxSize="3" ml='2' color="gray.400" />
                              </FormLabel>
                               <DatePicker
                                  onDateChange={(selectedDateValue) =>
                                    handledatechange(selectedDateValue)
                                  }
                                  defaultDate={date}
                                  disableFutureDates={false}
                                  disablePastDates={true}
                                  minDate={new Date().toISOString()}
                                  placeholderProp="Date"
                                  calendarStlye={{left: "-18px",  right: "unset",top:'-340px'}}
                                  datePickerInputStyle={{borderRadius: '12px'}}
                                />
                            </Box>

                            {/* Referral Centers */}
                            <Box mt="2">
                              <FormLabel htmlFor="followup-date" fontSize="sm" fontWeight="medium" color="gray.700">
                                Referral Centers
                                <EditIcon boxSize="3" ml='2' color="gray.400" />
                              </FormLabel>
                               <DropdownInputForVitals
                                  variant="fullSide"
                                  dropDownPlace="Referral Centers"
                                  options={referralHospitalList}
                                  onClick={handleHospitalChange}
                                  onChange={hospitalChange}
                                  readOnly=""
                                  inputStyleCss={{w: "100%"}}
                                  inputValueProp={referralCenter}
                                  menuList={{ pos: "absolute", right: "-45px", minW: "300px" }}
                                  // maxLength={2}
                                />
                            </Box>
                            
                            {/* Discharge Type */}
                            <Box mt="4">
                              <FormLabel htmlFor="followup-date" fontSize="sm" fontWeight="medium" color="gray.700">
                                  Discharge Type
                              <EditIcon boxSize="3" ml='2' color="gray.400" />
                              </FormLabel>
                               <RadioGroup 
                                  value={dischargeType}
                                  onChange={setDischargeType}
                                  display='flex' 
                                  alignItems='center' 
                                  gap='0.75rem'
                                  flexDir={{ base: 'column', md: 'row' }}
                                >
                                 
                                    <Radio colorScheme="green" value="lama">LAMA</Radio>
                                    <Radio colorScheme="green" value="dora">DORA</Radio>
                                    <Radio colorScheme="green" value="other">Other</Radio>
                                </RadioGroup> 

                                {dischargeType == 'other' && (
                                  <Textarea
                                    mt='2'
                                    id="other-discharge-type"
                                    placeholder="Please specify"
                                    value={dischargeTypeText}
                                    onChange={(e) => setDischargeTypeText(e.target.value)}
                                  />
                                )}
                            </Box>
                            <PrimaryButton variant='mdBtn' btnStyle={{w:'100%', mt: '0.75rem'}} buttonText={isSavedDischarge ? 'Edit Discharge' : 'Save Discharge'} onClick={()=> dischargePatientModal.current.openModal()} />
                          </Box>
                        </CardBody>
                      </Card>
                  </Flex>
                  )}
                </>)}
                {!ShowThanksScreen && selectedImages.length > 0 && (
                  <>
                    <Box w="100%">
                      <Box
                        w="100%"
                        p="32px"
                        bg="#E6E7E9"
                        overflow="hidden auto"
                        height="calc(100vh - 70px)"
                      >
                        {selectedImages.map((file, index) => (
                          <Box
                            key={index}
                            display="flex"
                            flexDirection="column"
                            pb="20px"
                            alignItems="center"
                            justifyContent="center"
                          >
                            {file.type.includes("pdf") ? (
                              <Box
                                as="iframe"
                                src={file.url}
                                title={`Document Preview - ${file.name}`}
                                w={{ base: "100%", md: "calc(100vw - 70%)" }}
                                boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                                h="700px"
                              />
                            ) : (
                              <Image
                                src={file.url}
                                alt={file.name}
                                w={{ base: "100%", md: "calc(100vw - 70%)" }}
                                h="auto"
                                borderRadius="8px"
                                boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                              />
                            )}
                            <Text fontSize="14px" mt="8px">{file.name}</Text>
                            <Button
                              mt="10px"
                              onClick={() => handleRemoveFile(file.name)}
                              colorScheme="red"
                            >
                              Remove
                            </Button>
                          </Box>
                        ))}
                      </Box>

                      {previewDoc && (
                        <Box
                          w={{ base: "100%", md: "calc(100vw - 70%)" }}
                          display="flex"
                          marginInline="auto"
                          alignItems="center"
                          gap="20px"
                          pos="sticky"
                          bottom="0"
                        >
                          <Input
                            type="file"
                            accept=".pdf,.png,.jpg"
                            hidden
                            id="uploaddocument"
                            multiple
                            onChange={(e) => handleUploadDocument(e)}
                          />
                          <PrimaryButton
                            buttonText="Re-upload"
                            id="uploaddocument"
                            variant="grayBtnFull"
                            onClick={handleuploadDocumentAttachment}
                          />
                            <PrimaryButton onClick={handleUploadFiles} buttonText="Confirm" />
                          {/* {dischargeSummary == 1 ? (
                            <PrimaryButton onClick={handleUploadFiles} buttonText="Confirm" />
                          ) : (
                            <PrimaryButton
                              onClick={handleUploadBase}
                              buttonText="Confirm"
                              isDisabled={!isChatbotAllowed()}
                              opacity={isChatbotAllowed() ? 1 : 0.6}
                              cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                            />
                            // <PrimaryButton onClick={handleUploadBase} buttonText="Confirm" />
                          )} */}

                        </Box>
                      )}
                    </Box>
                  </>
                )}
                {/* </>)} */}
                {!ShowThanksScreen && data && data.length > 0 && (
                  <>

                    {/* Discharge summary section start */}
                    <Box
                      width="100%"
                      // p={4}
                      h='calc(100vh - 75px)'
                      overflowY="scroll"
                      sx={{
                        "::-webkit-scrollbar": {
                          display: "none", // Hide scrollbar
                        },
                        msOverflowStyle: "none", // For Internet Explorer
                        scrollbarWidth: "none", // For Firefox
                      }}
                    >
                      <Tabs>
                        <TabList height={"auto"} justifyContent='space-between' borderBottom={"1px solid #e2e2e2"}>
                          <Flex>
                            <Tab
                              //   onClick={() => handleTabChange("doctor")}
                              _selected={{
                                color: "black",
                                borderBottom: "2px solid black",
                              }}
                              fontSize={{ base: "12px", lg: "initial" }}
                            >
                              Summary
                            </Tab>
                            {/* <Tab
                          onClick={() => handleTabChange("patient")}
                          _selected={{
                              color: "black",
                              borderBottom: "2px solid black",
                          }}
                          fontSize={{ base: "12px", lg: "initial" }}
                          >
                          Patient History
                          </Tab>
                          <Tab
                          onClick={() => handleTabChange("share")}
                          _selected={{
                              color: "black",
                              borderBottom: "2px solid black",
                          }}
                          fontSize={{ base: "12px", lg: "initial" }}
                          >
                          Share Details
                          </Tab> */}
                          </Flex>

                          <Flex gap='1rem' p='0.75rem 0.875rem'>
                            <PrimaryButton variant='mdBtn' onClick={sendEmail} buttonText='Send Email' />
                            <PrimaryButton variant='mdBtn' onClick={downloadSummary} buttonText='Download' />
                          </Flex>
                        </TabList>
                        <TabPanels
                          height="100%"
                          overflowY="auto"
                          p={4}
                          // mt="2rem"
                          sx={{
                            "::-webkit-scrollbar": {
                              display: "none", // Hide scrollbar
                            },
                            msOverflowStyle: "none", // For Internet Explorer
                            scrollbarWidth: "none", // For Firefox
                          }}
                        >
                          <TabPanel p={0}>
                            {/* {aiResponse && aiResponse?.chiefcomplaint && ( */}
                            {data.map((item, index) => (
                              <Box mb={4} id="content-to-download">
                                <Flex
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Heading as="h4" size="md">
                                    {/* Chief Complaint */}
                                    {item.header}
                                  </Heading>
                                  <Spacer />

                                </Flex>
                                <Textarea
                                  value={item.text}
                                  onChange={(e) => handlechangetext(e.target.value, index)} // Update state on change
                                //resize="none"
                                />
                              </Box>

                            ))}
                            {/* )} */}


                          </TabPanel>
                          <TabPanel p={{ base: "0" }}>
                            {/* {aiPatientResponse &&
                          aiPatientResponse?.patient_medical_conditions && ( */}
                            <Box mb={4}>
                              <Flex
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Heading as="h4" size="md">
                                  Medical Conditions
                                </Heading>
                                <Spacer />
                                {/* {fromStartVisit && ( */}
                                <IconButton
                                  aria-label="Save Medical Conditions"
                                  icon={<FaRegSave />}
                                  //   onClick={() =>
                                  //     addMedicalCondition(
                                  //       aiPatientMedicalConditions
                                  //     )
                                  //   }
                                  variant="ghost"
                                />
                                {/* )} */}
                                <IconButton
                                  aria-label="Copy Medical Conditions"
                                  icon={<CopyIcon />}
                                  onClick={() =>
                                    copyToClipboard("aiPatientMedicalConditions")
                                  }
                                  variant="ghost"
                                />
                                <IconButton
                                  aria-label="Clear Medical Conditions"
                                  icon={<CgRemove />}
                                  // onClick={() =>
                                  //   setAiPatientMedicalConditions("")
                                  // }
                                  variant="ghost"
                                />
                              </Flex>
                              <Textarea
                                value={"The patient reports experiencing pain in the head."}
                                //   onChange={(e) =>
                                //     setAiPatientMedicalConditions(e.target.value)
                                //   } // Update state on change
                                resize="none"
                              />
                            </Box>
                            {/* )} */}

                            <Text fontWeight="bold" color="black" fontSize="sm">
                              AIRA strives to be as accurate as possible, but
                              occasional errors may occur. Please verify its responses
                              to ensure the information meets your needs.
                              Occasionally, it may provide incorrect information or
                              recommend something if required. Your discretion will
                              ensure the best experience.
                            </Text>
                          </TabPanel>

                          <TabPanel p={{ base: "0" }}>
                            {/* Share record options available here */}
                            <Box mb={4}>
                              <Flex
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Heading as="h4" size="md">
                                  Email Information
                                </Heading>
                                <Spacer />

                                <IconButton
                                  aria-label="Copy Email"
                                  icon={<CopyIcon />}
                                  onClick={() =>
                                    copyToClipboard("shareReportDoctorEmail")
                                  }
                                  variant="ghost"
                                />
                                <IconButton
                                  aria-label="Clear Email"
                                  icon={<CgRemove />}
                                  // onClick={() => setShareReportDoctorEmail("")}
                                  variant="ghost"
                                />
                              </Flex>
                              <Textarea
                                value={"shareReportDoctorEmail"}
                                //   onChange={(e) =>
                                //     setShareReportDoctorEmail(e.target.value)
                                //   } // Update state on change
                                resize="none"
                              />
                              <Heading as="h4" size="md" mt={6}>
                                Details:
                              </Heading>
                              <Stack spacing={2} mt={2}>
                                <Checkbox
                                // isChecked={shareChatSummary}
                                // onChange={(e) =>
                                //   setShareChatSummary(e.target.checked)
                                // }
                                >
                                  Share chat summary
                                </Checkbox>
                                <Checkbox
                                // isChecked={shareChatHistory}
                                // onChange={(e) =>
                                //   setShareChatHistory(e.target.checked)
                                // }
                                >
                                  Share chat history
                                </Checkbox>
                                <Checkbox
                                // isChecked={shareDoctorNotes}
                                // onChange={(e) =>
                                //   setShareDoctorNotes(e.target.checked)
                                // }
                                >
                                  Share Doctor Notes
                                </Checkbox>
                                <Checkbox
                                // isChecked={sharePatientHistory}
                                // onChange={(e) =>
                                //   setSharePatientHistory(e.target.checked)
                                // }
                                >
                                  Share patient history
                                </Checkbox>
                              </Stack>

                              <Button
                                isDisabled={false} // Update with your `disabled` variable if needed
                                className="primary-button-icon" // Replace with your desired `btnClass`
                                //   onClick={shareNotesOnEmail}
                                sx={{
                                  h: "2.5rem",
                                  w: "8rem",
                                  p: "1rem",
                                  m: "0",
                                  mt: "48px",
                                  bg: COLORS.PRIMARY_GRADIENT,
                                  color: COLORS.PRIMARY_WHITE,
                                  _hover: { bg: COLORS.PRIMARY_COLOR },
                                }}
                              >
                                <Box
                                  className="icon-img"
                                  as="span"
                                  sx={{ mr: "0.5rem" }}
                                >
                                  {" "}
                                  {/* Adjust `sx` as needed */}
                                  <Image
                                    src="/assets/imgs/email-icon.png"
                                    h={"24px"}
                                    w={"24px"}
                                  />
                                </Box>
                                <Text>Share</Text>
                              </Button>
                            </Box>
                          </TabPanel>
                        </TabPanels>
                      </Tabs>
                    </Box>
                    {/* Discharge summary section end */}
                  </>
                )}
                {ShowThanksScreen && (<>
                  <Flex flexDir="column" gap="15px" w="calc(100vw - 50%)">
                    <Box
                      as="button"
                      flexDir="column"
                      justifyContent="center"
                      alignItems="center"
                      w="100%"
                      p="20px"
                      gap="8px"
                      border="1px dashed #CDCFD4"
                      borderRadius="12px"
                    >

                      <Text fontSize="14px" color="#163E9E" fontWeight="600">
                        Thank you, Your discharge summary will be processed soon!
                      </Text>

                    </Box>
                  </Flex>
                </>)}
              </Flex>
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          <MobileNavbar />
          {isLoading && <Loader />}
          <MobileSecondaryNav
            header="Discharge Summary"
            handlebackarrow={() => navigate(`/home`)}
          />
          <Flex
            h="calc(100vh - 145px)"
            w="100%"
            justifyContent="center"
            alignItems="center"
            overflow='hidden auto'
          >
            {/* {hideSection && (<> */}
            {docUpload && (<>
              <Flex flexDir="column" gap="15px" w="calc(100vw - 50%)">
                <Input
                    type="file"
                    accept=".pdf,.png,.jpg,.docx,.doc"
                    //accept=".pdf"
                    hidden
                    id="uploaddocument"
                    multiple
                    onChange={(e) => handleUploadDocument(e)}
                  />
                {/* {dischargeSummary == 1 ? (
                  <Input
                    type="file"
                    accept=".pdf,.png,.jpg,.docx,.doc"
                    //accept=".pdf"
                    hidden
                    id="uploaddocument"
                    multiple
                    onChange={(e) => handleUploadDocument(e)}
                  />
                ) : (
                  <Input
                    type="file"
                    //accept=".pdf,.png,.jpg,.docx,.doc"
                    accept=".pdf"
                    hidden
                    id="uploaddocument"
                    onChange={(e) => handleUploadDocument(e)}
                  />
                )} */}

                <Box
                  as="button"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="center"
                  w="100%"
                  p="20px"
                  gap="8px"
                  border="1px dashed #CDCFD4"
                  borderRadius="12px"
                  onClick={handleuploadDocumentAttachment}

                >
                  <Image
                    w="20px"
                    m="auto"
                    mb="10px"
                    h="auto"
                    src="/assets/svgs/file-upload.svg"
                  />
                  <Text fontSize="14px" color="#163E9E" fontWeight="600">
                    Drop files here
                  </Text>
                  <Text fontWeight="400" fontSize="12px" color="#6A707D">
                    {/* PDF (max. 5mb) */}
                    PDF, DOC, PNG, JPG (max. 5mb)
                  </Text>
                  {/* {dischargeSummary == 1 ? (
                    <Text fontWeight="400" fontSize="12px" color="#6A707D">
                      PDF, DOC, PNG, JPG (max. 5mb)
                    </Text>
                  ) : (
                    <Text fontWeight="400" fontSize="12px" color="#6A707D">
                      PDF (max. 5mb)
                    </Text>
                  )} */}
                </Box>
              </Flex>
            </>)}
            {!ShowThanksScreen && selectedImages.length > 0 && hideMobile && (
              <>
                <Box w="100%" h='100%'>
                  <Box
                    w="100%"
                    p="32px"
                    h='100%'
                    bg="#E6E7E9"
                    overflow="hidden auto"
                  >
                    {selectedImages.map((file, index) => (
                      <Box
                        key={index}
                        display="flex"
                        flexDirection="column"
                        // pb="20px"
                        alignItems="center"
                        justifyContent="center"
                        bg='white'
                        boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                        p='1rem'
                      >
                        {file.type.includes("pdf") ? (
                          <Image
                            src="/assets/svgs/pdf-icon-1.svg"
                            title={`Document Preview - ${file.name}`}
                            w="100%"
                            h="auto"
                          />
                        ) : (
                          <Image
                            src={file.url}
                            alt={file.name}
                            w="100%"
                            // boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                            h="auto"
                            borderRadius="8px"
                          />
                        )}
                        <Text fontSize="14px" mt="8px">{file.name}</Text>
                        <Button
                          mt="10px"
                          onClick={() => handleRemoveFile(file.name)}
                          colorScheme="red"
                        >
                          Remove
                        </Button>
                      </Box>
                    ))}
                  </Box>
                  {previewDoc && (
                    <Box
                      w="100%"
                      display="flex"
                      marginInline="auto"
                      alignItems="center"
                      gap="20px"
                      pos="sticky"
                      bottom="75px"
                      px='32px'
                    >
                      <Input
                        type="file"
                        accept=".pdf,.png,.jpg"
                        hidden
                        id="uploaddocument"
                        multiple
                        onChange={(e) => handleUploadDocument(e)}
                      />
                      <PrimaryButton
                        buttonText="Re-upload"
                        id="uploaddocument"
                        variant="grayBtnFull"
                        onClick={handleuploadDocumentAttachment}
                      />
                        <PrimaryButton onClick={handleUploadFiles} buttonText="Confirm" />

                      {/* {dischargeSummary == 1 ? (
                        <PrimaryButton onClick={handleUploadFiles} buttonText="Confirm" />
                      ) : (
                        <PrimaryButton onClick={handleUploadBase} buttonText="Confirm" />
                      )} */}

                    </Box>
                  )}

                </Box>
              </>
            )}
            {/* </>)} */}
            {!ShowThanksScreen && data && data.length > 0 && (
              <>

                {/* Discharge summary section start */}
                <Box
                  width="100%"
                  // p={4}
                  h='calc(100vh - 75px)'
                  overflowY="scroll"
                  sx={{
                    "::-webkit-scrollbar": {
                      display: "none", // Hide scrollbar
                    },
                    msOverflowStyle: "none", // For Internet Explorer
                    scrollbarWidth: "none", // For Firefox
                  }}
                >
                  <Tabs>
                    <TabList height={"auto"} justifyContent='space-between' borderBottom={"1px solid #e2e2e2"}>
                      <Flex>
                        <Tab
                          //   onClick={() => handleTabChange("doctor")}
                          _selected={{
                            color: "black",
                            borderBottom: "2px solid black",
                          }}
                          fontSize={{ base: "12px", lg: "initial" }}
                        >
                          Summary
                        </Tab>
                        {/* <Tab
                          onClick={() => handleTabChange("patient")}
                          _selected={{
                              color: "black",
                              borderBottom: "2px solid black",
                          }}
                          fontSize={{ base: "12px", lg: "initial" }}
                          >
                          Patient History
                          </Tab>
                          <Tab
                          onClick={() => handleTabChange("share")}
                          _selected={{
                              color: "black",
                              borderBottom: "2px solid black",
                          }}
                          fontSize={{ base: "12px", lg: "initial" }}
                          >
                          Share Details
                          </Tab> */}
                      </Flex>

                      <Flex gap='1rem' p='0.75rem 0.875rem'>
                        <PrimaryButton variant='mdBtn' onClick={sendEmail} buttonText='Send Email' />
                        <PrimaryButton variant='mdBtn' onClick={downloadSummary} buttonText='Download' />
                      </Flex>
                    </TabList>
                    <TabPanels
                      height="100%"
                      overflowY="auto"
                      p={4}
                      // mt="2rem"
                      sx={{
                        "::-webkit-scrollbar": {
                          display: "none", // Hide scrollbar
                        },
                        msOverflowStyle: "none", // For Internet Explorer
                        scrollbarWidth: "none", // For Firefox
                      }}
                    >
                      <TabPanel p={0}>
                        {/* {aiResponse && aiResponse?.chiefcomplaint && ( */}
                        {data.map((item, index) => (
                          <Box mb={4} id="content-to-download">
                            <Flex
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Heading as="h4" size="md">
                                {/* Chief Complaint */}
                                {item.header}
                              </Heading>
                              <Spacer />

                            </Flex>
                            <Textarea
                              value={item.text}
                              onChange={(e) => handlechangetext(e.target.value, index)} // Update state on change
                            //resize="none"
                            />
                          </Box>

                        ))}
                        {/* )} */}


                      </TabPanel>
                      <TabPanel p={{ base: "0" }}>
                        {/* {aiPatientResponse &&
                          aiPatientResponse?.patient_medical_conditions && ( */}
                        <Box mb={4}>
                          <Flex
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Heading as="h4" size="md">
                              Medical Conditions
                            </Heading>
                            <Spacer />
                            {/* {fromStartVisit && ( */}
                            <IconButton
                              aria-label="Save Medical Conditions"
                              icon={<FaRegSave />}
                              //   onClick={() =>
                              //     addMedicalCondition(
                              //       aiPatientMedicalConditions
                              //     )
                              //   }
                              variant="ghost"
                            />
                            {/* )} */}
                            <IconButton
                              aria-label="Copy Medical Conditions"
                              icon={<CopyIcon />}
                              onClick={() =>
                                copyToClipboard("aiPatientMedicalConditions")
                              }
                              variant="ghost"
                            />
                            <IconButton
                              aria-label="Clear Medical Conditions"
                              icon={<CgRemove />}
                              // onClick={() =>
                              //   setAiPatientMedicalConditions("")
                              // }
                              variant="ghost"
                            />
                          </Flex>
                          <Textarea
                            value={"The patient reports experiencing pain in the head."}
                            //   onChange={(e) =>
                            //     setAiPatientMedicalConditions(e.target.value)
                            //   } // Update state on change
                            resize="none"
                          />
                        </Box>
                        {/* )} */}

                        <Text fontWeight="bold" color="black" fontSize="sm">
                          AIRA strives to be as accurate as possible, but
                          occasional errors may occur. Please verify its responses
                          to ensure the information meets your needs.
                          Occasionally, it may provide incorrect information or
                          recommend something if required. Your discretion will
                          ensure the best experience.
                        </Text>
                      </TabPanel>

                      <TabPanel p={{ base: "0" }}>
                        {/* Share record options available here */}
                        <Box mb={4}>
                          <Flex
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Heading as="h4" size="md">
                              Email Information
                            </Heading>
                            <Spacer />

                            <IconButton
                              aria-label="Copy Email"
                              icon={<CopyIcon />}
                              onClick={() =>
                                copyToClipboard("shareReportDoctorEmail")
                              }
                              variant="ghost"
                            />
                            <IconButton
                              aria-label="Clear Email"
                              icon={<CgRemove />}
                              // onClick={() => setShareReportDoctorEmail("")}
                              variant="ghost"
                            />
                          </Flex>
                          <Textarea
                            value={"shareReportDoctorEmail"}
                            //   onChange={(e) =>
                            //     setShareReportDoctorEmail(e.target.value)
                            //   } // Update state on change
                            resize="none"
                          />
                          <Heading as="h4" size="md" mt={6}>
                            Details:
                          </Heading>
                          <Stack spacing={2} mt={2}>
                            <Checkbox
                            // isChecked={shareChatSummary}
                            // onChange={(e) =>
                            //   setShareChatSummary(e.target.checked)
                            // }
                            >
                              Share chat summary
                            </Checkbox>
                            <Checkbox
                            // isChecked={shareChatHistory}
                            // onChange={(e) =>
                            //   setShareChatHistory(e.target.checked)
                            // }
                            >
                              Share chat history
                            </Checkbox>
                            <Checkbox
                            // isChecked={shareDoctorNotes}
                            // onChange={(e) =>
                            //   setShareDoctorNotes(e.target.checked)
                            // }
                            >
                              Share Doctor Notes
                            </Checkbox>
                            <Checkbox
                            // isChecked={sharePatientHistory}
                            // onChange={(e) =>
                            //   setSharePatientHistory(e.target.checked)
                            // }
                            >
                              Share patient history
                            </Checkbox>
                          </Stack>

                          <Button
                            isDisabled={false} // Update with your `disabled` variable if needed
                            className="primary-button-icon" // Replace with your desired `btnClass`
                            //   onClick={shareNotesOnEmail}
                            sx={{
                              h: "2.5rem",
                              w: "8rem",
                              p: "1rem",
                              m: "0",
                              mt: "48px",
                              bg: COLORS.PRIMARY_GRADIENT,
                              color: COLORS.PRIMARY_WHITE,
                              _hover: { bg: COLORS.PRIMARY_COLOR },
                            }}
                          >
                            <Box
                              className="icon-img"
                              as="span"
                              sx={{ mr: "0.5rem" }}
                            >
                              {" "}
                              {/* Adjust `sx` as needed */}
                              <Image
                                src="/assets/imgs/email-icon.png"
                                h={"24px"}
                                w={"24px"}
                              />
                            </Box>
                            <Text>Share</Text>
                          </Button>
                        </Box>
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                </Box>
                {/* Discharge summary section end */}
              </>
            )}
            {ShowThanksScreen && (<>
              <Flex flexDir="column" gap="15px" w="calc(100vw - 50%)">
                <Box
                  as="button"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="center"
                  w="100%"
                  p="20px"
                  gap="8px"
                  border="1px dashed #CDCFD4"
                  borderRadius="12px"
                >

                  <Text fontSize="14px" color="#163E9E" fontWeight="600">
                    Thank you, Your discharge summary will be processed soon!
                  </Text>

                </Box>
              </Flex>
            </>)}
          </Flex>
        </>
      )}


      <DynamicModal
        ref={airaTranscribeNotes}
        modalHeader="Aira: Discharge Notes"
        hasHeader={false}
        modalWidth={"100vw"}
        modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* <TranscribeNotes /> */}
            {useGPUChatbot && localStorage.getItem("capableGPU") === "true" ? (
              <>
                {patientDischargeType && (
                  <>
                    {/* {alert("GPU Chatbot with Patient Discharge Type - First GPUChunksTranscribeNotes")} */}
                    <GPUChunksTranscribeNotes
                      patientId={patientid ? patientid : null}
                      doctorId={null}
                      appointmentId={appointmentid ? appointmentid : null}
                      isDischargeTypeStatus={true}
                      ipdInputStatus={patientIpdData}
                      buttonStatus={ipdClicked}
                      showSuccessToast={showSuccessToast}
                      showErrorToast={showErrorToast}
                      closeNotesModal={() => airaTranscribeNotes.current.closeModal()}
                      fetchPatientHealthData={() => { }}
                      fromStartVisit={false}
                    />
                  </>
                )}
                {!patientDischargeType && (
                  <>
                    {/* {alert("GPU Chatbot - Second GPUChunksTranscribeNotes")} */}
                    <GPUChunksTranscribeNotes
                      patientId={null}
                      doctorId={null}
                      appointmentId={null}
                      showSuccessToast={showSuccessToast}
                      showErrorToast={showErrorToast}
                      closeNotesModal={() => airaTranscribeNotes.current.closeModal()}
                      fetchPatientHealthData={() => { }}
                      fromStartVisit={false}
                      isDischargeSummary={true}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                {patientDischargeType && (
                  <>
                    {/* {alert("CPU Chatbot with Patient Discharge Type - First CPUChunksTranscribeNotes")} */}
                    <CPUTranscribeNotes
                      patientId={patientid ? patientid : null}
                      doctorId={null}
                      appointmentId={appointmentid ? appointmentid : null}
                      isDischargeTypeStatus={true}
                      ipdInputStatus={patientIpdData}
                      buttonStatus={ipdClicked}
                      showSuccessToast={showSuccessToast}
                      showErrorToast={showErrorToast}
                      closeNotesModal={() => airaTranscribeNotes.current.closeModal()}
                      fetchPatientHealthData={() => { }}
                      fromStartVisit={false}
                    // isDischargeSummary={true}
                    />
                  </>
                )}

                {!patientDischargeType && (
                  <>
                    {/* {alert("CPU Transcribe Notes")} */}
                    <CPUTranscribeNotes
                      patientId={null}
                      doctorId={null}
                      appointmentId={null}
                      showSuccessToast={showSuccessToast}
                      showErrorToast={showErrorToast}
                      closeNotesModal={() => airaTranscribeNotes.current.closeModal()}
                      fetchPatientHealthData={() => { }}
                      fromStartVisit={false}
                      isDischargeSummary={true}
                    />
                  </>
                )}
              </>
            )}
          </>
        }
      />
      <DynamicModal
        ref={audioCompatibilityDemo}
        modalHeader="Aira: Config"
        modalWidth={"100vw"}
        modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* <AIRA CHAT NOTES /> */}
            <AudioCompatibilityCheck modalRef={audioCompatibilityDemo} openRecordFunction={handleAIRANotesClick} />
          </>
        }
      />

      <DisplayNotesModal
        ref={ipdTranscribeNotes}
        closeAction={() => {
          // if (fromStartVisit) {
          //   fetchPatientHealthData();
          //   console.log("calling patient health data and doctor notes");
          //   fetchDoctorNotes();
          // }
          ipdTranscribeNotes.current.closeModal();
        }}
        modalHeader="Aira: IPD Discharge Notes"
        // modalHeader={isDischargeSummary ? "Aira: Discharge Notes": "Aira: Notes"}
        // modalWidth={voice ? "100vw" : ""}
        // modalWidth="100vw"
        modalWidth="50vw"
        // modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* {voice || initialVoice || translatedTranscript? ( */}
            <TranscriptNotesCard
              patientId={patientid}
              doctorId={getLoginID()}
              appointmentId={appointmentid}
              showSuccessToast={showSuccessToast}
              showErrorToast={showErrorToast}
              // transcriptionText={
              //   langSelector === "Multi-lingual"
              //     ? translatedTranscript
              //     : initialVoice
              //     ? initialVoice + " " + onDeviceVoiceInput
              //     : onDeviceVoiceInput
              // }
              // transcriptionText={demoText}
              // transcriptionArray={[]}
              // fromStartVisit={fromStartVisit}
              isIPDDischarge={true}
              ipdInput={patientIpdData}
              buttonClicked={ipdClicked}
            />
            {/* ) : (
              "No Data Available, Please record something before using this feature."
            )} */}
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Close"
              w="200px"
              mx="auto"
              onClick={() => ipdTranscribeNotes.current.closeModal()}
            />
          </>
        }
      />

      <DynamicModal
          ref={dischargePatientModal}
          modalHeader={`Discharge Patient?`}
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to Discharge?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                // variant="deleteBtn"
                buttonText={isSavedDischarge ? "Update Discharge" : "Discharge"}
                btnStyle={{
                  w: "100%",
                  h: "2.5rem",
                }}
                onClick={() => {
                  handleDischargeNotes();
                }}
              />
            </>
          }
        />
    </>
  );
};

export default DischargeSummaryIndex;
